module.exports = __webpack_public_path__ + "img/e-imza-bilgilendirme.c4457664.jpg";